module.exports = __webpack_public_path__ + "static/media/tile_mobile.f159237a.svg";